module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/subscriptions/plans/subscription-plans.component.css
// module id = ./src/app/components/subscriptions/plans/subscription-plans.component.css
// module chunks = main